import React, { useCallback, useEffect, useMemo } from "react";
import useMenu from "../../../hooks/useMenuContext";
import useAuth from "../../../hooks/useAuthContext";
import "./menuAdm.css";
import iconeMenu from "../../../assets/header/icone_menu.png";
import ItemMenu from "./itemMenuAdm";

import { IoMdLogOut } from "react-icons/io";
import { AiOutlineAudit } from "react-icons/ai";
import { FaPaperclip, FaUsers, FaUserCog } from "react-icons/fa";
import { MdSpaceDashboard } from "react-icons/md";
import { BiHome } from "react-icons/bi";
import {
  BsBell,
  BsStar,
  BsFillBriefcaseFill,
  BsCalendar3,
  BsCalendarPlus,
  BsListCheck,
  BsUpcScan,
  BsSpeedometer2,
  BsJournalText,
  BsFileEarmarkBarGraph,
} from "react-icons/bs";

const ROLES_ADM = ["administracao", "administracao_dash"];
const ROLES_ADMIN_FULL = ["administracao"];
const ROLES_RECEPCAO = ["recepcao"];

const ITENS_MENU_ADM = [
  {
    id: "dashboard",
    label: "Dashboard",
    link: "/private/adm",
    Icon: MdSpaceDashboard,
    roles: ROLES_ADM,
  },
  {
    id: "patrocinadores",
    label: "Patrocinadores",
    link: "/private/adm/patrocinadores",
    Icon: BsStar,
    roles: ROLES_ADM,
  },
  {
    id: "convidados",
    label: "Convidados",
    link: "/private/adm/convidados",
    Icon: FaUsers,
    roles: ROLES_ADM,
  },
  {
    id: "usuarios",
    label: "Usuários",
    link: "/private/adm/usuarios",
    Icon: FaUserCog,
    roles: ROLES_ADMIN_FULL,
  },
  {
    id: "etiquetas",
    label: "Etiquetas",
    link: "/private/adm/etiquetas",
    Icon: BsUpcScan,
    roles: ROLES_ADMIN_FULL,
  },
  {
    id: "agenda-adm",
    label: "Agenda Adm",
    link: "/private/adm/agenda/04",
    Icon: BsCalendar3,
    roles: ROLES_ADM,
  },
  {
    id: "gerar-agendamento",
    label: "Gerar agendamento",
    link: "/private/adm/gerar-agendamento",
    Icon: BsCalendarPlus,
    roles: ROLES_ADMIN_FULL,
  },
  {
    id: "agenda-logs",
    label: "Logs agenda",
    link: "/private/adm/agenda-logs",
    Icon: BsJournalText,
    roles: ROLES_ADMIN_FULL,
  },
  {
    id: "conteudos",
    label: "Conteudos",
    link: "/private/adm/eventos/04",
    Icon: AiOutlineAudit,
    roles: ROLES_ADM,
  },
  {
    id: "entregas",
    label: "Entregas",
    link: "/private/adm/reunioes",
    Icon: BsFillBriefcaseFill,
    roles: ROLES_ADM,
  },
  {
    id: "monitor-entregas",
    label: "Monitor entregas",
    link: "/private/adm/entregas-monitor",
    Icon: BsSpeedometer2,
    roles: ROLES_ADM,
  },
  {
    id: "relatorios",
    label: "Relatórios",
    link: "/private/adm/relatorios",
    Icon: BsFileEarmarkBarGraph,
    roles: ROLES_ADM,
  },
  {
    id: "portal-patrocinadores",
    label: "Portal Patrocinadores",
    link: "/portal-patrocinador",
    Icon: FaPaperclip,
    roles: ROLES_ADM,
  },
  {
    id: "notificacoes",
    label: "Notificações",
    link: "/private/adm/notificacoes",
    Icon: BsBell,
    roles: ROLES_ADMIN_FULL,
  },
  {
    id: "recepcao",
    label: "Recepção",
    link: "/private/adm/recepcao",
    Icon: BsListCheck,
    roles: ROLES_RECEPCAO,
  },
  {
    id: "home",
    label: "Home",
    link: "/private/",
    Icon: BiHome,
    roles: ROLES_ADM,
  },
];

const Menu = () => {
  const { menuIsOpen, toggleMenu, closeMenu } = useMenu();
  const { logout, usuario } = useAuth();

  const itensVisiveis = useMemo(() => {
    const tipo = usuario?.tipo;
    if (!tipo) return [];
    return ITENS_MENU_ADM.filter((item) => item.roles.includes(tipo));
  }, [usuario?.tipo]);

  const handleLogout = useCallback(() => {
    closeMenu();
    logout();
  }, [closeMenu, logout]);

  useEffect(() => {
    if (!menuIsOpen) return undefined;
    const onKeyDown = (event) => {
      if (event.key === "Escape") closeMenu();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [menuIsOpen, closeMenu]);

  return (
    <div
      id="container-menu"
      className={`container-menu ${menuIsOpen ? "mostrar-menu" : "esconder-menu"}`}
      aria-hidden={!menuIsOpen}
      inert={!menuIsOpen}
    >
      <div className="menu-panel">
        <div id="menu-title" className="menu-title">
          <button
            type="button"
            className="menu-botao"
            id="menu-botao"
            onClick={toggleMenu}
            aria-label="Fechar menu"
            aria-expanded={menuIsOpen}
          >
            <img src={iconeMenu} alt="" />
          </button>
          <h2 className="titulo-menu">Menu de configurações</h2>
          <button
            type="button"
            id="btn-logout"
            className="btn-logout"
            onClick={handleLogout}
            title="Logout"
            aria-label="Logout"
          >
            <IoMdLogOut />
          </button>
        </div>

        <div id="menu-body" className="menu-body">
          {itensVisiveis.map(({ id, label, link, Icon }) => (
            <ItemMenu
              key={id}
              Icon={Icon}
              label={label}
              link={link}
              onNavigate={closeMenu}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Menu;
